import React from "react";
import { Entity } from "@common/types/entity";
import { ConsolidationRelationshipResponse } from "@common/schemas/domains/accounting/consolidation.schema";
import { PaneSection } from "./PaneSection";
import { RelationshipProperties } from "./RelationshipProperties";
import styles from "./Pane.module.scss";

interface RelationshipPaneProps {
    relationship: ConsolidationRelationshipResponse;
    entitiesByUuid: Map<string, Entity>;
}

export const RelationshipPane: React.FC<RelationshipPaneProps> = ({
    relationship,
    entitiesByUuid,
}) => (
    <div className={styles.pane}>
        {relationship.metadata?.name && (
            <div className={styles.paneTitle}>{relationship.metadata.name}</div>
        )}
        <PaneSection title="Properties" defaultExpanded>
            <RelationshipProperties
                relationship={relationship}
                entitiesByUuid={entitiesByUuid}
            />
        </PaneSection>
    </div>
);
